/**
 * from ESIS.Web
 */

export default {
   parseISODate(dateString: string): Date | null {
      if (!dateString)
         return null;
      try {
         let split = dateString.split("T");
         if (split.length == 1) {
            split = dateString.split(" ");
         }
         if (split.length == 1) {
            split.push("00:00");
         }
         if (split.length !== 2) {
            return null;
         }

         let dateSplit = split[0].split("-");
         let timeSplit = split[1].split(":");
         if (dateSplit.length !== 3 || !(timeSplit.length === 2 || timeSplit.length === 3)) {
            return null;
         }

         let years = parseInt(dateSplit[0]);
         let months = parseInt(dateSplit[1]) - 1;
         let days = parseInt(dateSplit[2]);

         let hours = parseInt(timeSplit[0]);
         let minutes = parseInt(timeSplit[1]);

         return new Date(years, months, days, hours, minutes);
      } catch (error) {
         return null;
      }
   },
   
   formatISODate(date: Date): string {
      //return 2020-09-23
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         date.getFullYear() +
         "-" +
         pad2(date.getMonth() + 1) +
         "-" +
         pad2(date.getDate())
      );
   },

   formatISODateTime(date: Date): string {
      //return 2020-09-23T10:09
      return this.formatISODate(date) + "T" + this.formatTime(date);
   },

   parseWeekdayDate(dateString: string): Date | null {
      let dateRegex = /^( )*((So|Mo|Di|Mi|Do|Fr|Sa),( )?)?([0-2]?[0-9]|(3)[0-1])(\.)(((0)?[0-9])|((1)[0-2]))(\.)\d{4}( )*$/;

      if (!dateRegex.test(dateString)) return null;

      var dateSplit = dateString.replace(" ", "").split(",");
      if (dateSplit.length > 2 || dateSplit.length < 1) return null;

      dateSplit =
         dateSplit.length == 1
            ? dateSplit[0].split(".")
            : dateSplit[1].split(".");
      if (dateSplit.length !== 3) return null;

      let years = parseInt(dateSplit[2]);
      let months = parseInt(dateSplit[1]) - 1;
      let days = parseInt(dateSplit[0]);

      return new Date(years, months, days);
   },

   formatWeekdayDate(date: Date | null): string {
      //return Mi, 23.09.2020
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      var weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         weekDays[date.getDay()] +
         ", " +
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "." +
         date.getFullYear()
      );
   },

   formatDateLong(date: Date | null): string {
      //return 23. September 2020
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      let months = [
         "Januar",
         "Februar",
         "März",
         "April",
         "Mai",
         "Juni",
         "Juli",
         "August",
         "September",
         "Oktober",
         "November",
         "Dezember"
      ];

      return (
         date.getDate() +
         ". " +
         months[date.getMonth()] +
         " " +
         date.getFullYear()
      );
   },

   formatDateTime(date: Date | null): string {
      //return 23.09.2020 10:09
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "." +
         date.getFullYear() +
         " " +
         pad2(date.getHours()) +
         ":" +
         pad2(date.getMinutes())
      );
   },

   formatTime(date: Date | null): string {
      //return 10:09
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getHours()) +
         ":" +
         pad2(date.getMinutes())
      );
   },

   formatDateShort(date: Date | null): string {
      //return 23.09.20
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "." +
         pad2(date.getFullYear())
      );
   },

   formatDateMedium(date: Date | null): string {
      //return 23.09.2020
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "." +
         date.getFullYear()
      );
   },

   formatWeekdayDateTimeLong(date: Date | null): string {
      //return Mittwoch, 23. Sep. um 10:09
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      var weekDays = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      let months = [
         "Jan.",
         "Feb.",
         "Mär.",
         "Apr.",
         "Mai",
         "Jun.",
         "Jul.",
         "Aug.",
         "Sep.",
         "Okt.",
         "Nov.",
         "Dez."
      ];
      return (
         weekDays[date.getDay()] +
         ", " +
         date.getDate() +
         ". " +
         months[date.getMonth()] +
         " um " +
         pad2(date.getHours()) +
         ":" +
         pad2(date.getMinutes())
      );
   },

   formatWeekdayDateTimeShort(date: Date | null): string {
      //return Mi, 23.09 10:09
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      var weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         weekDays[date.getDay()] +
         ", " +
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         " " +
         pad2(date.getHours()) +
         ":" +
         pad2(date.getMinutes())
      );
   },

   /* new */
   parseTime(timeString: string): Date | null {
      //hh:mm
      if (!timeString)
         return null;
      try {
         let timeSplit = timeString.split(":");
         if (timeSplit.length == 2) {
            let hours = parseInt(timeSplit[0]);
            let minutes = parseInt(timeSplit[1]);

            return new Date(1970, 0, 1, hours, minutes);
         } else {
            return null;
         }
      } catch (error) {
         return null;
      }
   },

   formatDateWeekday(date: Date | null): string {
      //return 23.09.2020 (Mi)
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      var weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "." +
         date.getFullYear() +
         " (" +
         weekDays[date.getDay()] +
         ")"
      );
   },

   formatDayMonth(date: Date | null): string {
      //return 23.09.
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getDate()) +
         "." +
         pad2(date.getMonth() + 1) +
         "."
      );
   },

   formatUSDate(date: Date): string {
      //return 09/23/2020
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         pad2(date.getMonth() + 1) +
         "/" +
         pad2(date.getDate()) +
         "/" +
         date.getFullYear()
      );
   },

   formatFilenameDateTime(date: Date | null): string {
      //return 20200903-1009
      if (date == null || isNaN(date.getTime())) return "unbekannt";

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         date.getFullYear() +
         pad2(date.getMonth() + 1) +
         pad2(date.getDate()) +
         "-" +
         pad2(date.getHours()) +
         pad2(date.getMinutes()) +
         pad2(date.getSeconds())
      );
   },

   parseDateString(dateString: string): Date | null {
      //3.9.2020 || 03.09.2020
      var split = dateString.split('.');

      return (new Date(parseInt(split[2]), parseInt(split[1]) - 1, parseInt(split[0])));
   },

   formatDateShortNoSpecialChars(date: Date): string {

      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return pad2(date.getFullYear() - 2000) +
         pad2(date.getMonth() + 1) +
         pad2(date.getDate());
   },

   getCalendarWeek(date: Date): number {
      let year = date.getFullYear();

      const weekdays = [6, 0, 1, 2, 3, 4, 5];

      //thanks to https://die-aktuelle-kalenderwoche.de/kalenderwochen-in-javascript
      let currThu = new Date(date.getTime() + (3 - weekdays[date.getDay()] * 86400000));
      let firstThu = new Date(new Date(year, 0, 4).getTime() + (3 - weekdays[new Date(year, 0, 4).getDay()] * 86400000));

      let calWeek = Math.floor(1 + 0.5 + (currThu.getTime() - firstThu.getTime()) / 86400000 / 7);

      return calWeek;
   },
};